import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Container,
  Box,
  Button,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  makeStyles
} from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';

import BillingDatatable from '../components/BillingDatatable';
import generateBilling from 'src/billing/use-cases/generateBilling';
import downloadCustomerInvoicePdfById from 'src/customer-invoice/use-cases/downloadCustomerInvoicePdfById';
import downloadBillingInvoiceListExcel from 'src/billing/use-cases/downloadBillingInvoiceListExcel';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  button: {
    margin: theme.spacing(1)
  },
  buttonExportExcel: {
    left: '30px',
    top: '10px'
  }
}));

const BillingView = () => {
  const companyHeadquarterId = localStorage.selectedUserHeadquarter;
  const classes = useStyles();
  const [showBilling, setShowBilling] = useState(true);
  const [
    showSelectDownloadCustomerInvoiceType,
    setShowSelectDownloadCustomerInvoiceType
  ] = useState(false);
  const [
    selectedDownloadCustomerInvoiceId,
    setSelectedDownloadCustomerInvoiceId
  ] = useState(null);

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [exportExcelDialogVisible, setExportExcelDialogVisible] = useState(
    false
  );

  const navigate = useNavigate();

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const yearStart = new Date(Date.UTC(new Date().getUTCFullYear(), 0, 1))
      .toISOString()
      .split('T')[0];

    setFromDate(yearStart);
    setToDate(today);
  }, []);

  const handleClickGenerateBilling = async (event, id) => {
    const isConfirmed = confirm(
      '¿Está seguro? Asegúrese de que todos los contratos del ciclo de facturación estén en ALTA'
    );
    if (!isConfirmed) {
      return;
    }

    const result = await generateBilling();
    if (result && result.statusCode === 201) {
      alert('Facturas generadas satisfactoriamente.');
      setShowBilling(false);
      setShowBilling(true);
    } else {
      alert('No se encontraron cuotas pendientes para generar la facturación');
    }
  };

  const handleDownloadCustomerInvoice = async (id) => {
    setSelectedDownloadCustomerInvoiceId(id);
    setShowSelectDownloadCustomerInvoiceType(true);
  };

  const handleDialogSelectDownloadCustomerInvoiceType = (type) => {
    setShowSelectDownloadCustomerInvoiceType(false);
    downloadCustomerInvoicePdfById(selectedDownloadCustomerInvoiceId, type);
  };

  const handleDialogCloseDownloadCustomerInvoice = async (id) => {
    setShowSelectDownloadCustomerInvoiceType(false);
  };

  const handleClickEdit = (event, id) => {
    navigate(`/app/billing/${id}`, {
      replace: false
    });
  };

  const handleClickExportExcel = () => {
    setExportExcelDialogVisible(true);
  };

  const handleDialogCloseExport = async () => {
    setExportExcelDialogVisible(false);
  };

  const handleFromDateChange = (event) => {
    setFromDate(event.target.value);
  };

  const handleToDateChange = (event) => {
    setToDate(event.target.value);
  };

  const downloadExcel = (event) => {
    event.preventDefault();

    setExportExcelDialogVisible(false);

    downloadBillingInvoiceListExcel({ companyHeadquarterId, fromDate, toDate });
  };

  return (
    <Page className={classes.root} title="Facturas">
      <Dialog
        onClose={handleDialogCloseDownloadCustomerInvoice}
        aria-labelledby="simple-dialog-title"
        open={showSelectDownloadCustomerInvoiceType}
      >
        <DialogTitle id="simple-dialog-title">
          Seleccione el tipo de factura
        </DialogTitle>
        <List>
          <ListItem
            button
            onClick={() =>
              handleDialogSelectDownloadCustomerInvoiceType(
                'ORIGINAL_AND_DUPLICATE'
              )
            }
            key={'ORIGINAL_AND_DUPLICATE'}
          >
            <ListItemText primary={'Original'} />
          </ListItem>
          <ListItem
            button
            onClick={() =>
              handleDialogSelectDownloadCustomerInvoiceType('CUSTOMER')
            }
            key={'CUSTOMER'}
          >
            <ListItemText primary={'Digital'} />
          </ListItem>
        </List>
      </Dialog>

      <Dialog
        onClose={handleDialogCloseExport}
        aria-labelledby="simple-dialog-title"
        open={exportExcelDialogVisible}
      >
        <DialogTitle id="export-excel-dialog">
          Seleccione el intervalo
        </DialogTitle>
        <List>
          <ListItem>Desde</ListItem>
          <ListItem>
            <input
              type="date"
              id="from-date"
              name="fromDate"
              value={fromDate}
              onChange={handleFromDateChange}
            />
          </ListItem>
          <ListItem>Hasta</ListItem>
          <ListItem>
            <input
              type="date"
              id="to-date"
              name="toDate"
              value={toDate}
              onChange={handleToDateChange}
            />
          </ListItem>
          <ListItem key={'DOWNLOAD'}>
            <Button
              className={classes.buttonExportExcel}
              color="primary"
              variant="contained"
              onClick={downloadExcel}
            >
              Exportar
            </Button>
          </ListItem>
        </List>
      </Dialog>

      <Container maxWidth={false}>
        {JSON.parse(localStorage.user).surnames === 'Prieto González' && (
          <div>
            <Box display="flex" justifyContent="flex-end">
              <Button
                className={classes.button}
                color="primary"
                variant="contained"
                onClick={handleClickGenerateBilling}
              >
                Generar facturación mensual
              </Button>
            </Box>
          </div>
        )}
        {showBilling ? (
          <BillingDatatable
            handleDownload={handleDownloadCustomerInvoice}
            handleClickExportExcel={handleClickExportExcel}
            handleEdit={handleClickEdit}
          />
        ) : (
          <></>
        )}
      </Container>
    </Page>
  );
};

export default BillingView;
